import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type FormData } from "@client/controls/Form/component";
import { apiAction } from "@client/lib/actions";
import { type BaseAppState, type EntityRef, Status } from "@client/types";
import { type AnyAction, type Dispatch } from "redux";
import api from "./api";
import { localStateSelector } from "./selectors";

export enum Actions {
  SubmitBegin = "FORGOT_PASSWORD_SUBMIT_BEGIN",
  SubmitFailure = "FORGOT_PASSWORD_SUBMIT_FAILURE",
  SubmitSuccess = "FORGOT_PASSWORD_SUBMIT_SUCCESS"
}

export type SubmitBeginActionData = EntityRef & {
  email: string;
};
export interface SubmitSuccessActionData {}
const _submit = apiAction<BaseAppState, SubmitBeginActionData, SubmitSuccessActionData>({
  types: {
    begin: Actions.SubmitBegin,
    failure: Actions.SubmitFailure,
    success: Actions.SubmitSuccess
  },
  action: (state: BaseAppState, dispatch: Dispatch<AnyAction>, args: SubmitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);

    return api.submit(apiInfo, { email: args.email, portalId: state.portal.id });
  }
});

export const submit = (ref: EntityRef, data: FormData) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, ref);

  if (localState.status !== Status.Saving) {
    dispatch(_submit({ ...ref, email: data.email }));
  }
};
